import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Card
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.material.Text
import androidx.compose.material.darkColors
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.Density
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import article.neumorphism.NEUMORPHISM_SAMPLE
import article.neumorphism.NeumorphismSample
import article.spring.SPRING_ANIMATION
import article.spring.SPRING_DAMPING
import article.spring.SPRING_DRAG
import article.spring.SPRING_EXPANDABLE_DRAWER
import article.spring.SPRING_INTRO
import article.spring.SPRING_SCALE_BALL
import article.spring.SPRING_STIFFNESS
import article.spring.SPRING_TRANSLATE_BALL
import article.spring.SPRING_VISIBILITY_THRESHOLD
import article.spring.SPRING_VS_DURATION
import article.spring.SpringAnimation
import article.spring.SpringDamping
import article.spring.SpringDrag
import article.spring.SpringExpandableDrawer
import article.spring.SpringIntro
import article.spring.SpringScaleBall
import article.spring.SpringStiffness
import article.spring.SpringTranslateBall
import article.spring.SpringVisibilityThreshold
import article.spring.SpringVsDuration
import article.spring.TWEEN_EXPANDABLE_DRAWER
import article.spring.TweenExpandableDrawer
import demos.animatedContent.BLURRED_NUMBER_CHANGE
import demos.animatedContent.BlurredTimeAnimation
import demos.buttons.CALL_BUTTON
import demos.buttons.CallButton
import demos.buttons.FLIP_BUTTON
import demos.buttons.FlipButton
import demos.buttons.GLOW_BUTTON
import demos.buttons.GRADIENT_BUTTON
import demos.buttons.GlowButton
import demos.buttons.GradientButton
import demos.buttons.HOLD_TO_CONFIRM
import demos.buttons.HoldToConfirm
import demos.buttons.LIKE_BUTTON
import demos.buttons.LOG_IN_BUTTON
import demos.buttons.LikeButton
import demos.buttons.LoginButton
import demos.buttons.RATING_BUTTON
import demos.buttons.ROTATE_BUTTON
import demos.buttons.RatingView
import demos.buttons.RotateButton
import demos.buttons.STACKED_BUTTON
import demos.buttons.STATE_BUTTON
import demos.buttons.StackedButton
import demos.buttons.StateButton
import demos.buttons.THREE_D_BUTTON
import demos.buttons.ThreeDButton
import demos.coil.ImageScaleType
import demos.coil.PAGER
import demos.counter.COUNTER_BASIC_ANIMATION
import demos.counter.COUNTER_FINAL
import demos.counter.COUNTER_SIMPLE
import demos.counter.CounterBasicAnimation
import demos.counter.CounterSimple
import demos.counter.FinalCounter
import demos.`fun`.ANDROID_LOGO
import demos.`fun`.AndroidLogo
import demos.`fun`.DIGITAL_CLOCK
import demos.`fun`.FOLLOWING_ARROWS
import demos.`fun`.FollowingArrows
import demos.`fun`.LEDSeconds
import demos.`fun`.MOTION_BLUR
import demos.`fun`.MotionBlur
import demos.`fun`.THREE_D_CAROUSEL
import demos.`fun`.ThreeDCarousel
import demos.`fun`.UI2024
import demos.`fun`.UI_2024
import demos.`fun`.WORDLE_ANDROID
import demos.`fun`.WordleAndroid
import demos.loading.RADAR_LOADING
import demos.loading.RadarLoading
import demos.loading.SPINNING_CIRCLE_LOADER
import demos.loading.SpinningCircleLoader
import demos.switch.BASIC_SLIDER
import demos.switch.BasicSlider
import demos.switch.LOOP_SWITCH
import demos.switch.LoopSwitch
import demos.switch.NEUMORPHIC_TOGGLE
import demos.switch.NeumorphicToggle
import demos.switch.REAL_SWITCH
import demos.switch.RealSwitch
import playground.gradient.GRADIENT_PLAYGROUND
import playground.gradient.GradientPlayground

val yellow = Color(0xfff0df8b)
val blue = Color(0xff5189f0)


@Composable
fun MainView(text: String) {
//    var defaultFontFamily: FontFamily? by remember { mutableStateOf(null) }
//
//    LaunchedEffect(Unit) {
//        defaultFontFamily = getDefaultFontFamily()
//    }
//
//    defaultFontFamily?.let { defaultFontFamily ->
        MaterialTheme(
            colors = darkColors(
                surface = Color(0xff000000)
            ),
//            typography = Typography(
//                defaultFontFamily = defaultFontFamily
//            )
        ) {
            Surface {
                Card(
                    modifier = Modifier.padding(8.dp),
                    backgroundColor = Color(0xff212121),
                    shape = RoundedCornerShape(12.dp)
                ) {
                    val density = LocalDensity.current
                    CompositionLocalProvider(
                        LocalDensity provides Density(
                            density = density.density * 1.5f,
                            fontScale = 1f
                        )
                    ) {


                        Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                            when (text) {
                                COUNTER_SIMPLE -> CounterSimple()
                                COUNTER_BASIC_ANIMATION -> CounterBasicAnimation()
                                COUNTER_FINAL -> FinalCounter()
                                PAGER -> ImageScaleType()

                                GRADIENT_BUTTON -> GradientButton()
                                GLOW_BUTTON -> GlowButton()
                                STACKED_BUTTON -> StackedButton()
                                ROTATE_BUTTON -> RotateButton()
                                STATE_BUTTON -> StateButton()
                                CALL_BUTTON -> CallButton()
                                FLIP_BUTTON -> FlipButton()
                                HOLD_TO_CONFIRM -> HoldToConfirm()
                                LIKE_BUTTON -> LikeButton()
                                LOG_IN_BUTTON -> LoginButton()
                                RATING_BUTTON -> RatingView()
                                THREE_D_BUTTON -> ThreeDButton()

                                SPINNING_CIRCLE_LOADER -> SpinningCircleLoader()
                                RADAR_LOADING -> RadarLoading()

                                BASIC_SLIDER -> BasicSlider()
                                LOOP_SWITCH -> LoopSwitch()
                                REAL_SWITCH -> RealSwitch()
                                NEUMORPHIC_TOGGLE -> NeumorphicToggle()

                                BLURRED_NUMBER_CHANGE -> BlurredTimeAnimation()

                                GRADIENT_PLAYGROUND -> GradientPlayground()

                                SPRING_ANIMATION -> SpringAnimation()
                                SPRING_INTRO -> SpringIntro()
                                SPRING_SCALE_BALL -> SpringScaleBall()
                                SPRING_TRANSLATE_BALL -> SpringTranslateBall()
                                SPRING_DRAG -> SpringDrag()
                                SPRING_DAMPING -> SpringDamping()
                                SPRING_STIFFNESS -> SpringStiffness()
                                SPRING_VISIBILITY_THRESHOLD -> SpringVisibilityThreshold()
                                SPRING_EXPANDABLE_DRAWER -> SpringExpandableDrawer()
                                TWEEN_EXPANDABLE_DRAWER -> TweenExpandableDrawer()
                                SPRING_VS_DURATION -> SpringVsDuration()

                                NEUMORPHISM_SAMPLE -> NeumorphismSample()

                                FOLLOWING_ARROWS -> FollowingArrows()
                                THREE_D_CAROUSEL -> ThreeDCarousel()
                                ANDROID_LOGO -> AndroidLogo()
                                UI_2024 -> UI2024()
                                WORDLE_ANDROID -> WordleAndroid()
                                DIGITAL_CLOCK -> LEDSeconds()
                                MOTION_BLUR -> MotionBlur()

                                else -> Error404()
                            }
                        }
                    }
                }
            }
        }
//    } ?: run {
//        Text(
//            "Loading . . . ",
//            fontSize = 80.sp,
//            fontWeight = FontWeight.Bold,
//            style = MaterialTheme.typography.h1,
//        )
//    }
}

@Composable
fun Error404() {
    Column(
        modifier = Modifier.fillMaxSize(),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Text(
            "4.0.4\n not found",
            fontSize = 80.sp,
            fontWeight = FontWeight.Bold,
            style = MaterialTheme.typography.h1,
            textAlign = TextAlign.Center,
        )
    }
}